import i18n from '@ms/lang/i18n'
import BetPush from './lib/BetPush'

const productCode = Number(process.env.VUE_APP_PRODUCT_CODE || i18n.t('PRODUCT_CODE'))

const push = new BetPush({
  productCode
})

export default push
